import React from "react"
import { createContext } from "use-context-selector"
import { useAppContextState } from "../../@hooks"
import { getAppUserData } from "../../@utils"

const AppMainHotelsContext = createContext(null)

export function AppMainHotelsProvider({children}) {
    const { mainHotelsSectionData, userId } = getAppUserData()
    const data = mainHotelsSectionData || {}
    let idMainHotel = null

    if (!window.location.href.includes('logout')) {
        const isAllMode = localStorage.getItem('packagesAllHotelsMode') === 'true'
        if (isAllMode) {
            idMainHotel = null
        } else {
            const stored = localStorage.getItem('selectedMainHotel')
            const storedId = stored && stored !== 'null' ? parseInt(stored) : null
            idMainHotel = storedId || data[userId]?.['hotels']?.idHotel?.[0] || null
        }
    }

    const initialState = {
        mainHotels: idMainHotel,
        isSetHotel: false,
        forceRemount: null
    }
    const { state, replaceState, resetState, updateState } = useAppContextState(initialState)



    return <AppMainHotelsContext.Provider value={{state, replaceState, updateState, resetState}}>
        {children}
    </AppMainHotelsContext.Provider>

}

export default AppMainHotelsContext